export default __webpack_public_path__ + "static/media/AKM_9.7264693d.png";